<div class="layer-toggle">
  <button
    class="layer-tab"
    [class.active]="activeLayer === 'codebook'"
    (click)="setActiveLayer('codebook')"
  >
    Codebook
  </button>
  <button
    class="layer-tab"
    [class.active]="activeLayer === 'konto'"
    (click)="setActiveLayer('konto')"
  >
    Chart of Accounts
  </button>
  <button
    class="layer-tab"
    [class.active]="activeLayer === 'schema'"
    (click)="setActiveLayer('schema')"
  >
    Schema
  </button>
  <button
    class="layer-tab"
    [class.active]="activeLayer === 'organizationalUnits'"
    (click)="setActiveLayer('organizationalUnits')"
  >
    Organizational Unit
  </button>
  <button
    class="layer-tab"
    [class.active]="activeLayer === 'employees'"
    (click)="setActiveLayer('employees')"
  >
    Employees
  </button>
  <button
    class="layer-tab"
    [class.active]="activeLayer === 'priceList'"
    (click)="setActiveLayer('priceList')"
  >
    Price List (MPC)
  </button>
</div>

<app-sifrarnik-table *ngIf="activeLayer === 'codebook'"></app-sifrarnik-table>
<app-employees-table *ngIf="activeLayer === 'employees'"></app-employees-table>
<app-chart-of-accounts-table *ngIf="activeLayer === 'konto'"></app-chart-of-accounts-table>
<app-account-schema-table *ngIf="activeLayer === 'schema'"></app-account-schema-table>
<app-organizational-units-table *ngIf="activeLayer === 'organizationalUnits'"></app-organizational-units-table>
<app-price-list-table *ngIf="activeLayer === 'priceList'"></app-price-list-table>
